import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Event, Router, Routes } from '@angular/router';
import { Observable } from 'rxjs';
import { UpdateLoggedIn } from '../../statemanagement/actions/user.actions';
import { CorporateClientState } from '../../statemanagement/corporate-client.state';

@Injectable()
export class MyRouter {

    constructor(private router: Router,
                private store: Store<{ corporateClient: CorporateClientState }>) {
    }

    url(): string {
        return this.router.url;
    }

    events(): Observable<Event> {
        return this.router.events;
    }

    isActive(url: string, exact: boolean): boolean {
        return this.router.isActive(url, exact);
    }

    navigateToLogin() {
        this.store.dispatch(new UpdateLoggedIn(false));
        return this.router.navigate(['/auth/login']);
    }

    navigate(url: string[]) {
        return this.router.navigate(url);
    }

    navigateWithCorporateClient(url: string[], queryParams?: URLSearchParams): Promise<any> {
        return new Promise((resolve, reject) => {
            this.store.pipe(
                select('corporateClient'),
                first())
                .subscribe({
                    next: (client: CorporateClientState) => {
                        let params = {};
                        if (queryParams) {
                            queryParams.delete('corporate-client');
                            queryParams.forEach((value, key) => {
                                if (key in params) {
                                    params[key].push(value);
                                } else {
                                    params[key] = [value];
                                }
                            });
                        }

                        if (client && client.corporateClientId) {
                            params = {...params, 'corporate-client': client.corporateClientId};
                        }

                        resolve(this.router.navigate(url, {queryParams: params}));
                    }, error: () => resolve(this.router.navigate(url, {queryParams}))
                });
        });
    }

    resetConfig(config: Routes) {
        return this.router.resetConfig(config);
    }

    config() {
        return this.router.config;
    }

    routeReuseStrategy() {
        return this.router.routeReuseStrategy;
    }
}
